import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { StateService } from '../../services/state.service';

import { VerificationResponseDto } from '../../adapter/dto/verification-response.dto';

/**
 * Checks whether the token has already been verified
 */
export const verifyResultGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
  const router: Router = inject(Router);
  const stateService: StateService = inject(StateService);
  const verifyResult: VerificationResponseDto | null = stateService.getVerificationResponse();
  const token: string | null = route.paramMap.get('token');
  const next: string = state.url;

  if (verifyResult === null) {
    return router.createUrlTree(['/vp', token], { queryParams: { next } });
  }
  if (!verifyResult.datenschutzeinwilligung) {
    return router.createUrlTree(['/vp', token, 'datenschutz'], { queryParams: { next } });
  }
  if (!verifyResult.verschwiegenheitsverpflichtung) {
    return router.createUrlTree(['/vp', token, 'verschwiegenheit'], { queryParams: { next } });
  }
  return true;
};
